import { render } from "./AdminProjects.vue?vue&type=template&id=65da3121&scoped=true&ts=true"
import script from "./AdminProjects.vue?vue&type=script&lang=ts"
export * from "./AdminProjects.vue?vue&type=script&lang=ts"

import "./AdminProjects.vue?vue&type=style&index=0&id=65da3121&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65da3121"]])

export default __exports__